import { TextInput, useTranslate } from 'react-admin'

const RetailerAddressFormInputs = (props) => {
    const translate = useTranslate()

    return (
        <>
            <TextInput
                fullWidth
                source="address_label"
                variant="outlined"
                label={translate('manager.resources.retailerAddress.address_label')}
            />

            <TextInput
                fullWidth
                source="id"
                variant="outlined"
                label={translate('manager.resources.retailerAddress.id')}
            />

            <TextInput
                fullWidth
                source="street"
                variant="outlined"
                label={translate('manager.resources.retailerAddress.street')}
            />

            <TextInput
                fullWidth
                source="city"
                variant="outlined"
                label={translate('manager.resources.retailerAddress.city')}
            />

            <TextInput
                fullWidth
                source="post_code"
                variant="outlined"
                label={translate('manager.resources.retailerAddress.post_code')}
            />

            <TextInput
                fullWidth
                source="country_code"
                variant="outlined"
                label={translate('manager.resources.retailerAddress.country_code')}
            />
        </>
    )
}

export default RetailerAddressFormInputs
